import { render, staticRenderFns } from "./SearchResultPickup.vue?vue&type=template&id=2bc1b4e2&scoped=true"
import script from "./SearchResultPickup.vue?vue&type=script&lang=js"
export * from "./SearchResultPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1b4e2",
  null
  
)

export default component.exports